import { getAuthUser, getSelectedTenant } from "./../utils/authToken";
import axios from "axios";
import { API_BASE } from "../constant";
import { storeUser } from "../utils/authToken";
import localforage from "localforage";
import { OFFLINE_DATA_KEY, OFFLINE_QUEUE_KEY } from "../redux/hybridStorage";

const login = (email: string, password: string) => {
  return axios
    .post(`${API_BASE}user/login`, {
      email,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        storeUser(response.data);
      }
      return response.data;
    });
};

const register = (payload: any) => {
  const user = getAuthUser();
  const tenantId = getSelectedTenant();
  return axios
    .post(`${API_BASE}user`, payload, {
      headers: {
        Authorization: "Bearer " + user.accessToken,
        "tenant-id": tenantId !== null ? tenantId : "",
      },
    })
    .then((response) => {
      return response.data;
    });
};
const logout = () => {
  localStorage.clear();
  localforage.removeItem(OFFLINE_DATA_KEY);
  localforage.removeItem(OFFLINE_QUEUE_KEY);
};
export default {
  register,
  login,
  logout,
};
